import { Head } from "@inertiajs/react";

const MetaData = ({
  description,
  image,
  title,
}: {
  description?: string;
  image?: string;
  title: string;
}) => {
  const suffixedTitle = `${title} - Solidaritijd`;

  return (
    <Head title={suffixedTitle}>
      <meta content={suffixedTitle} name="og:title" />
      {description && <meta content={description} name="description" />}
      {description && <meta content={description} name="og:description" />}
      <meta content="Solidaritijd" name="og:site_name" />
      <meta content="nl_NL" name="og:locale" />
      {image && <meta content={image} name="og:image" />}
      <meta content="summary_large_image" name="twitter:card" />
    </Head>
  );
};

export default MetaData;
